import { usePunditUserContext } from "@circle-react/contexts";
import { useIsMemberToMemberMessagingEnabled } from "@circle-react/hooks/useIsMessagingEnabled";

export const useShouldShowMessageButton = ({
  member,
  shouldHideMessageButton = false,
}: {
  member: any;
  shouldHideMessageButton?: boolean;
}) => {
  const { currentCommunityMember } = usePunditUserContext();
  const isCurrentCommunityMemberProfile =
    currentCommunityMember?.id == member?.id;
  const isAdminUser = currentCommunityMember?.is_admin;

  const isMemberToMemberMessagingEnabled =
    useIsMemberToMemberMessagingEnabled();

  return Boolean(
    !shouldHideMessageButton &&
      !member?.is_deleted &&
      !isCurrentCommunityMemberProfile &&
      currentCommunityMember?.messaging_enabled &&
      (member?.messaging_enabled || (isAdminUser && !member?.admin)) &&
      isMemberToMemberMessagingEnabled,
  );
};
